import React, { FC } from 'react';
import { Typography, Button } from '@mui/material';

import styled from 'styled-components';
import { colors } from '../../../common/styles/colors';
import { Routes } from '../../../common/enums/routes';
import Link from 'next/link';
import { ChatIcon } from '../../../common/components/Icon/Icons/ChatIcon.icon';
import { ChatBubbleOutlineRounded } from '@mui/icons-material';

export const AiPepaCard: FC = () => {
  return (
    <Link
      href={Routes.AiAdviser}
      style={{ textDecoration: 'none', width: '100%', height: '100%' }}
    >
      <CardWrapper>
        <IconWrapper>
          <div
            style={{
              width: 48,
              height: 48,
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'white',
              fontSize: '24px',
            }}
          >
            <ChatIcon />
          </div>
        </IconWrapper>

        <Title variant="h3">AI Buddy</Title>

        <Description variant="body1">
          Tvůj AI průvodce startupovým světem. Prober s ním jakékoliv téma, od
          validace problému až po rozvoj podnikání. Ptej se kdykoliv budeš
          potřebovat.
        </Description>

        <ChatButton
          variant="contained"
          startIcon={<ChatBubbleOutlineRounded width={24} height={24} />}
        >
          Chatovat
        </ChatButton>
      </CardWrapper>
    </Link>
  );
};

const CardWrapper = styled.div`
  padding: 0px;
  text-align: center;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;

const IconWrapper = styled.div`
  svg {
    color: ${colors.brand};
  }
`;

const Title = styled(Typography)`
  color: ${colors.brand};
  font-weight: 600;
  font-size: 22.2px;
`;

const Description = styled(Typography)`
  color: ${colors.brand};
  line-height: 1.6;
  margin-bottom: 24px;
  max-width: 280px;
`;

const ChatButton = styled(Button)`
  background-color: ${colors.buttonLightBlue};
  color: ${colors.brand};
  padding: 12px 24px;
  border-radius: 12px;
  font-weight: 400;
  text-transform: none;

  &:hover {
    background-color: ${colors.blueActive};
    color: ${colors.white};
  }
`;
